module.exports = __webpack_public_path__ + "static/media/miesasiakas-white.788a02fc.svg";